var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { buildOgImagePreviewUrl } from '../utils/build-og-image-preview';
var getImageObject = function (containerKey, images) {
    var _a;
    if (images === void 0) { images = []; }
    var imageObjects = images
        .filter(function (_a) {
        var url = _a.url;
        return !!url;
    })
        .map(function (_a) {
        var url = _a.url, width = _a.width, height = _a.height;
        return (__assign(__assign(__assign({ '@type': 'ImageObject' }, (height ? { height: height } : {})), (width ? { width: width } : {})), { url: buildOgImagePreviewUrl({ url: url, width: width, height: height }) }));
    });
    return imageObjects.length
        ? (_a = {},
            _a[containerKey] = imageObjects.length === 1
                ? __assign({}, imageObjects[0]) : imageObjects,
            _a) : {};
};
export { getImageObject };
